/*JM added this 9/9/2025 to disable the send button forget in touch page until all the fields input are valid*/
document.addEventListener("DOMContentLoaded", function () {
  // Target the container
  const formSection = document.querySelector('.contact-form-section');
  if (!formSection) return;

  const contactForm = formSection.querySelector('form');
  if (!contactForm) return;

  const submitButton = contactForm.querySelector('button[type="submit"], input[type="submit"]');
  if (!submitButton) return;

  // Disable the button initially
  submitButton.disabled = true;

  // Validation function
  function validateForm() {
    const requiredFields = contactForm.querySelectorAll("input[required], textarea[required]");
    let isValid = true;

    requiredFields.forEach(field => {
      if (!field.value.trim()) {
        isValid = false;
      } else if (field.type === "email" && !field.checkValidity()) {
        isValid = false;
      }
    });

    submitButton.disabled = !isValid;
  }

  // Watch for changes
  contactForm.addEventListener("input", validateForm);
  contactForm.addEventListener("change", validateForm);

  // Run on load (handles autofill)
  validateForm();
});

/*Klaviyo email matching validation 9/10/2025*/
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".shopify-section.private-allocation");
  if (!container) return;

  function initEmailValidation() {
    const emailInputs = container.querySelectorAll(".klaviyo-form-TvNfMJ input[placeholder*='Email']");
    if (emailInputs.length < 2) return;

    const emailField = emailInputs[0];
    const confirmField = emailInputs[1];
    const form = confirmField.closest("form");
    if (!form) return;

    // Avoid attaching twice
    if (confirmField.dataset.validationAttached) return;
    confirmField.dataset.validationAttached = "true";

    // Create error message
    const errorMessage = document.createElement("div");
    errorMessage.textContent = "Email addresses do not match.";
    errorMessage.style.color = "red";
    errorMessage.style.fontSize = "14px";
    errorMessage.style.marginTop = "4px";
    errorMessage.style.display = "none";

    confirmField.insertAdjacentElement("afterend", errorMessage);

    function validateEmails() {
      if (confirmField.value === "") {
        errorMessage.style.display = "none";
        confirmField.style.borderColor = "";
        return true;
      }

      if (emailField.value !== confirmField.value) {
        errorMessage.style.display = "block";
        confirmField.style.borderColor = "red";
        return false;
      } else {
        errorMessage.style.display = "none";
        confirmField.style.borderColor = "green";
        return true;
      }
    }

    // Live validation while typing
    emailField.addEventListener("input", validateEmails);
    confirmField.addEventListener("input", validateEmails);

    // Block form submission if mismatch
    form.addEventListener("submit", function (e) {
      if (!validateEmails()) {
        e.preventDefault();
        e.stopPropagation();
        confirmField.focus();
      }
    });
  }

  // Observe changes to detect when form/inputs load
  const observer = new MutationObserver(() => {
    initEmailValidation();
  });

  observer.observe(container, { childList: true, subtree: true });

  // Also try immediately (in case already present)
  initEmailValidation();
});




